import { PropsWithChildren } from 'react';

const DTMFButtons = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '*',
  '0',
  '#',
];

export const DialpadGrid = ({
  onDigitClick,
}: {
  onDigitClick: (digit: string) => void;
}) => (
  <div className="grid grid-cols-3 gap-4 mt-6">
    {DTMFButtons.map((digit) => (
      <DialpadButton key={digit} onClick={() => onDigitClick(digit)}>
        {digit}
      </DialpadButton>
    ))}
  </div>
);

const DialpadButton = ({
  children,
  onClick,
}: PropsWithChildren<{ onClick: () => void }>) => {
  return (
    <button
      className="bg-neutral-100 text-gray-900 size-12 rounded-full grid place-content-center border-none cursor-pointer hover:bg-neutral-300"
      onClick={onClick}
    >
      {children}
    </button>
  );
};
